<template>
    <a-menu theme="dark"
            mode="inline"
            v-model:selectedKeys="selectedKeys"
            v-model:openKeys="openKeys">

        <template v-for="item in menu">
            <a-sub-menu :key="'group-' + item.key"
                        :a="item.key"
                        v-if="item.sub">
                <template #icon>
                    <i class="n-icon n-icon-size-20 n-mr-2"
                       :class="'n-icon-' + item.icon"
                       v-if="item.icon"></i>
                </template>
                <template #title>{{item.title}}</template>

                <a-menu-item :key="sItem.key"
                             class="n-flex n-flex-a-c"
                             v-for="sItem in item.sub">
                    <i class="n-icon n-icon-size-20 n-mr-2"
                       :class="'n-icon-' + sItem.icon"
                       v-if="sItem.icon"></i>
                    <router-link :to="{ name: sItem.link}"
                                 v-if="sItem.link">{{sItem.title}}</router-link>
                    <span v-else>{{sItem.title}}</span>
                </a-menu-item>
            </a-sub-menu>

            <a-menu-item :key="item.key"
                         class="n-flex n-flex-a-c"
                         v-else>
                <template #icon>
                    <i class="n-icon n-icon-size-20 n-mr-2"
                       :class="'n-icon-' + item.icon"
                       v-if="item.icon"></i>
                </template>

                <router-link :to="{ name: item.link}"
                             v-if="item.link">{{item.title}}</router-link>
                <span v-else>{{item.title}}</span>
            </a-menu-item>
        </template>
    </a-menu>
</template>

<script>
    import { mapMutations, mapState } from 'vuex';

    import nui from '@/assets/script';
    import menu from '@/assets/script/menu'

    export default {
        name: 'Menu',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                menu: [],
                selectedKeys: [],
                openKeys: []
            })
        },
        watch: {
            '$route': function () {
                this.initMenuData();
            }
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setWindowSize', 'setLocation'])),

            NMounted () {
                this.menu = menu();

                setTimeout(() => {
                    this.initMenuData();
                }, 100);
            },
            /**
             * @description 渲染默认的菜单状态
             */
            initMenuData () {
                var routerName = this.$route.name

                if (!routerName) {
                    return
                }

                // this.selectedKeys = [0]
                // this.openKeys = ['1']

                this.selectedKeys = this.getCurrentMenuData(routerName).selectedKeys;
                this.openKeys = this.getCurrentMenuData(routerName).openKeys;

                var open, select

                if (this.openKeys[0]) {
                    open = this.menu.filter(item => item.key == this.openKeys[0].replace('group-', ''));

                    if (this.selectedKeys[0]) {
                        select = open[0].sub.filter(item => item.key == this.selectedKeys[0]);
                        this.setLocation(open.concat(select))
                    }

                    this.setLocation(open)
                }


            },
            getCurrentMenuData (routerName) {
                let selectedKeys, openKeys;

                this.menu.forEach(item => {
                    if (item.sub) {
                        item.sub.forEach(subItem => {
                            if (subItem.active && subItem.active.indexOf(routerName) >= 0) {
                                openKeys = 'group-' + item.key;
                                selectedKeys = subItem.key;
                                return
                            }
                        });
                    } else {
                        if (item.active.indexOf(routerName) >= 0) {
                            selectedKeys = item.key;
                            return
                        }
                    }
                });

                return {
                    selectedKeys: selectedKeys ? [selectedKeys] : [],
                    openKeys: openKeys ? [openKeys] : []
                }
            },
        }),
        components: {
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .el-menu {
        border-right: 0;
    }
</style>